import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CategoryPlans,
  DeleteCategoryPlans,
  CreateCategoryPlans,
  UpdateCategoryPlans,
} from '../../../store/actions';

/**
 * categoryPlans is responsible for injecting the methods about store of categoryPlans.
 *
 * @return
 *  categoryPlans: Array of categoryPlans.
 *  getCategoryPlans: () => Void
 *  createCategoryPlans: () => void
 *  updateCategoryPlans: () => void
 *  deleteCategoryPlans: () => void
 */
export const CategoryPlansInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getCategoryPlans = useCallback(() => {
    dispatch(CategoryPlans());
  }, [dispatch]);
  /**
   * @return Void
   */
  const deleteCategoryPlans = (id) => {
    dispatch(DeleteCategoryPlans(id));
  };

  const createCategoryPlans = (values) => {
    dispatch(CreateCategoryPlans(values));
  };

  const updateCategoryPlans = (id, values) => {
    dispatch(UpdateCategoryPlans(id, values));
  };

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * categoryPlans: object
   */
  const { error, loading, categoryPlans, resume } = useSelector((state) => ({
    error: state.CategoryPlans.error,
    loading: state.CategoryPlans.loading,
    categoryPlans: state.CategoryPlans.categoryPlans,
  }));

  return {
    createCategoryPlans,
    updateCategoryPlans,
    getCategoryPlans,
    deleteCategoryPlans,
    error,
    loading,
    categoryPlans,
  };
};
